import { useMemo } from "react";

const MOBILE_USER_AGENT = /android|iPhone|iPad|iPod|windows phone/i;

/**
 * React hook that reports whether the app is running on a phone or tablet.
 * @function
 *
 * The value is read once: a user agent cannot change mid-session, so there is
 * nothing to listen for. Note that iPadOS 13 and later report a desktop Safari
 * user agent and so read as `false`.
 */
export const useIsMobileDevice = (): boolean =>
  useMemo(
    () => MOBILE_USER_AGENT.test(navigator.userAgent || navigator.vendor),
    []
  );
